<template>
<div class="fc-page mg-page mg-article_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>文章管理</h1><p>管理机构文章内容、栏目与发布状态</p></div><div class="mg-heading-actions"><v-btn  @click="$router.push('/content/article/create')" color="#d9363e" depressed class="mg-create">添加文章</v-btn></div></header><section class="fc-filters" aria-label="文章管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-select :items="selectColList" v-model="query.colId"
						item-text="colName" item-value="id" label="栏目" dense outlined color="#d9363e" aria-label="栏目"></v-select></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="标题名称" outlined v-model="query.caption" color="#d9363e" aria-label="标题名称">
						</v-text-field></div>
<div class="fc-filter-cell"><v-select :items="statusItems" v-model="query.status"
						item-text="name" item-value="id" label="状态" dense outlined color="#d9363e" aria-label="状态"></v-select></div>
<div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							transition="scale-transition" offset-y
							min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="创建开始日期"></v-text-field>
							</template>
							<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
							</v-date-picker>
						</v-menu></div>
<div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="结束日期"></v-text-field>
							</template>
							<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
							</v-date-picker>
						</v-menu></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="文章列表"><div class="fc-list-heading"><h3>文章列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
				</v-chip>
			</template>
			<template v-slot:item.coverImg="{item}">

				<v-img v-if="item.coverImg" :src="imgPrev + item.coverImg" :aspect-ratio="15/4" width="375" class="mt-1 mb-1" ></v-img>

			</template>

			<template v-slot:item.action="{item}">
				<v-btn @click.stop="toEdit(item)" color="#d9363e" x-small depressed>修改</v-btn>
				<v-btn @click.stop="frozenArticle(item)" :disabled="item.status !== '1'" color="error" class="ml-3" x-small depressed>作废</v-btn>
				<v-btn @click.stop="freeArticle(item)" :disabled="item.status === '1'" color="#d9363e" class="ml-3" x-small depressed>启用</v-btn>

			</template>

		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section></div>
</template>

<script>
	
	import global from '../../../config/global'
	export default {
		name: "article-list",
		data() {
			return {
				imgPrev: global.config.imgPre,
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '内容管理',
						disabled: true
					},
					{
						text: '文章列表',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '栏目',
							value: 'colName',
							sortable: false,
							width:'300'
						},
						{
							text: '标题',
							value: 'caption',
							sortable: false,
							width:'400'
						},
						{
							text: '封面',
							value: 'coverImg',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectColList:[], //选择栏目数据源
				statusItems:[{id:"1",name:'正常'},{id:"0",name:'作废'}],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					caption: "",
					colId: "",
					status:"1"
				},
				
				
			}
		},
		created() {
			// 获取门店列表
			this.getColListForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			toEdit(item){
				this.$router.push({path:'/content/article/edit',query:{id:item.id}});
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},	
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/content/article/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.caption) {
					url += "&caption=" + this.query.caption;
				}
				if (this.query.colId) {
					url += "&colId=" + this.query.colId;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			
			showUpdate(item) {
				this.update.dialog = true;
				this.update.class.id = item.id;
				this.update.class.shopId = item.shopId;
				this.update.class.className = item.className;
				this.update.class.courseId = item.courseId;
		
				this.update.class.maxQty = item.maxQty;
				
				// 加载课程和教师
				this.getCourseListForSelect(this.update.class.shopId);
				
			},
			submitUpdateClass() {

				if (!this.update.class.shopId) {
					this.$noty.error('校区不能为空');
					return
				}
				if (!this.update.class.className) {
					this.$noty.error('班级名称不能为空');
					return
				}
	
				
				// api
				const that = this;
				let url = `/edu/class/update`;
			
				// parameters
				
				const updateData = {
					...this.update.class
				}
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			frozenArticle(item){
				//冻结
				const that = this;
				let url = `/content/article/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeArticle(item){
				//冻结
				const that = this;
				let url = `/content/article/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getColListForSelect(){
				const that = this;
				let url = `/content/col/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectColList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		},
		
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
